import { FormAPI, PanelAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import { HistoryService, MessageService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import providerContext from '../context/provider-context';

import { ProviderAccreditationPendenciesService } from './provider-accreditation-pendencies-service';
import { ProviderAccreditationStatusService } from './provider-accreditation-status-service';
import { ToastService } from './toast-service';

enum AccreditationUpdateStatus {
  AWAITING_REQUESTER_REGISTRATION = '1',
  AWAITING_REQUESTER_REVIEW = '3',
}

const REVISION = 'R';
class FormViewService {
  public static shouldRenderForm(api: PanelAPI, step?: string): void {
    const { nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    ProviderAccreditationStatusService.getAccreditationStatus(nrSeqAccreditation as number, nrSeqProvider)
      .then(({ body }) => {
        if (!body) return;
        const { status } = body;
        if (status == AccreditationUpdateStatus.AWAITING_REQUESTER_REGISTRATION || status == AccreditationUpdateStatus.AWAITING_REQUESTER_REVIEW) {
          if (status == AccreditationUpdateStatus.AWAITING_REQUESTER_REVIEW) {
            ProviderAccreditationPendenciesService.getPendencies(nrSeqAccreditation as number, nrSeqProvider, REVISION, step)
              .then((resp) => {
                if (isEmptyArrayOrObject(resp.body)) {
                  api.setVisible(false);
                }
              }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
          }
        } else {
          api.setVisible(false);
        }
      }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));

  }

  public static shouldEditForm(api: FormAPI, step?: string): void {
    const { nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    ProviderAccreditationStatusService.getAccreditationStatus(nrSeqAccreditation as number, nrSeqProvider)
      .then(({ body }) => {
        if (!body) return;
        const { status } = body;
        if (status == AccreditationUpdateStatus.AWAITING_REQUESTER_REGISTRATION || status == AccreditationUpdateStatus.AWAITING_REQUESTER_REVIEW) {
          if (step && status == AccreditationUpdateStatus.AWAITING_REQUESTER_REVIEW) {
            ProviderAccreditationPendenciesService.getPendencies(nrSeqAccreditation as number, nrSeqProvider, REVISION, step)
              .then((resp) => {
                if (isEmptyArrayOrObject(resp.body)) {
                  api.setEditing(false);
                  api.setLocked(true);
                }
              }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
          }
          api.setEditing(true);
          api.setLocked(false);
        } else {
          api.setEditing(false);
          api.setLocked(true);
        }
      }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
  }
}

export {
  FormViewService,
};
